import type { ReactNode } from 'react';
import type { TFunction } from 'i18next';

import styles from './ProviderSchemaField.module.scss';

export interface FieldLabelSuffixOptions {
    /** The save can do without a value: marked as every portal form marks one. */
    optional: boolean;
    /** The stored key, shown to OptoScale admins next to the label. */
    dbKey?: string;
}

/**
 * What FormField shows after a setting's label: the stored key for OptoScale admins, then the
 * optional mark. Both are for sight only and stay out of the label's accessible name: a box
 * the save needs carries aria-required, which says the same to assistive tech. Undefined when
 * there is neither, so FormField draws no suffix.
 */
export function fieldLabelSuffix(
    { optional, dbKey }: FieldLabelSuffixOptions,
    t: TFunction
): ReactNode {
    if (!optional && !dbKey) return undefined;
    return (
        <>
            {dbKey && (
                <code className={styles.dbKey} aria-hidden="true">
                    {dbKey}
                </code>
            )}
            {dbKey && optional && ' '}
            {optional && <span aria-hidden="true">{t('providerConfig.optionalMark')}</span>}
        </>
    );
}
